<script setup>
import { RouterLink } from 'vue-router';

defineProps({
  as: {
    type: [Object, String],
    default: RouterLink,
  },
  insetFocus: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <Component
    :is="as"
    :class="insetFocus ? 'focus:ring-inset' : 'focus:ring-offset-2'"
    class="inline-flex items-center text-red-600 hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-brand-blue">
    <slot />
  </Component>
</template>
